import { combineReducers } from "redux";

import { DashboardSlice } from "../pages/home/_redux/dashboard/Slice";

export const rootReducer = combineReducers({
  dashboard: DashboardSlice.reducer,
});
